import React from "react";
import { RiTimeLine, RiTeamLine, RiProjectorLine } from "react-icons/ri";
import SectionNavigation from "../../Utility/SectionNavigation";

const DEFAULT_NAV_ITEMS = [
  { id: "timesheet", icon: RiTimeLine, label: "My Timesheet" },
  { id: "team", icon: RiTeamLine, label: "Team Time Summary" },
  { id: "project", icon: RiProjectorLine, label: "Project Time Summary" },
];

const TimeEntryNavigation = ({ activeTab, onTabChange, items }) => {
  const navItems = items ?? DEFAULT_NAV_ITEMS;

  if (!navItems.length) {
    return null;
  }

  return <SectionNavigation items={navItems} activeTab={activeTab} onTabChange={onTabChange} />;
};

export default TimeEntryNavigation;
